
import subscriptionConstants from '@/constants/subscription.constants';

const { subscriptionPlans } = subscriptionConstants;

export default {
    name: 'FinAgentQuestionLeftCard',

    props: {
        variant: {
            type: String,
            required: true,
            validator: (value) => ['info', 'limit', 'faq'].includes(value)
        },
    },

    computed: {
        subsciptionLink() {
            return {
                name: this.$getTranslatedRouteName('subscription'),
                params: { plan: subscriptionPlans.ai }
            };
        },
        questionUsage() {
            return this.$store.state.finAgent.questionUsage;
        },
        warningMode() {
            return this.questionUsage.questionsLeft <= 3;
        },
        progressPercent() {
            return (this.questionUsage.questionsLeft / this.questionUsage.questionsLimit) * 100;
        }
    }
}
